import { render, staticRenderFns } from "./sub-item.vue?vue&type=template&id=fec64468&scoped=true&"
import script from "./sub-item.vue?vue&type=script&lang=ts&"
export * from "./sub-item.vue?vue&type=script&lang=ts&"
import style0 from "./sub-item.vue?vue&type=style&index=0&id=fec64468&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec64468",
  null
  
)

export default component.exports